import isMergeableObject from 'is-mergeable-object'

import { ObjectId } from '@/utils/objectid'

const transformValue = (value: any): any => {
    // -- transformers

    if (value?.$date && typeof value.$date === 'string') {
        return new Date(value.$date)
    }

    if (value?.$oid && typeof value.$oid === 'string') {
        return new ObjectId(value.$oid as string)
    }

    // -- end transformers

    if (Array.isArray(value)) {
        return value.map((val) => transformValue(val))
    }

    if (isMergeableObject(value)) {
        return Object.keys(value).reduce(
            (res, key) => ({
                ...res,
                [key]: transformValue(value[key]),
            }),
            {} as const
        )
    }

    return value
}

export const deserialize = (value: string) => {
    const obj = JSON.parse(value)

    return transformValue(obj)
}
